module.exports = __webpack_public_path__ + "img/hand3.ddc958b4.png";